/* ARCTA Zubehör: Landingpage „Ausrüstung“ und Zubehör-Produktseite (10/2026).
   Warenkorb per AJAX (öffnet den Theme-Warenkorb über „ajaxProduct:added“), Galerie, Varianten,
   Menge, Sticky-Leiste mobil, Anlass-Filter und Sortierung, „Weiterlesen“, „Passt dazu“. */
(function () {
  if (window.__azbInit) return;
  window.__azbInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var euro = function (cents) {
    var v = (Number(cents) || 0) / 100;
    var s = v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return s + ' €';
  };

  /* ---------- In den Warenkorb ---------- */
  function addToCart(body, buttons, msg, mainBtn) {
    if (msg) { msg.hidden = true; msg.textContent = ''; }
    buttons.forEach(function (b) { b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true'); });
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: body
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        buttons.forEach(function (b) { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); });
        if (!res.ok || res.data.status) {
          var text = (res.data && (res.data.description || res.data.message)) || 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.';
          if (msg) { msg.textContent = text; msg.hidden = false; } else { window.alert(text); }
          return;
        }
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res.data, addToCartBtn: mainBtn } }));
        buttons.forEach(function (b) {
          var label = b.querySelector('[data-azb-label]') || b;
          if (!b.dataset.azbOrig) b.dataset.azbOrig = label.textContent;
          label.textContent = b.hasAttribute('data-azb-quick') ? 'Drin' : 'Im Warenkorb';
          b.classList.add('is-done');
          setTimeout(function () { label.textContent = b.dataset.azbOrig; b.classList.remove('is-done'); }, 2200);
        });
      })
      .catch(function () {
        buttons.forEach(function (b) { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); });
        if (msg) { msg.textContent = 'Keine Verbindung. Bitte versuch es noch einmal.'; msg.hidden = false; }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-azb-add]')) return;
    e.preventDefault();
    var btn = e.submitter && form.contains(e.submitter) ? e.submitter : form.querySelector('[type="submit"]');
    var external = e.submitter && !form.contains(e.submitter) ? e.submitter : null;
    addToCart(new FormData(form), [btn, external].filter(Boolean), form.querySelector('[data-azb-msg]'), btn);
  });

  /* Kleine Zusatz-Buttons ohne Formular (Link zum Produkt als Rückfall ohne JS).
     Bewusst kein form/[name=add]: Apps auf der Produktseite schreiben solche Buttons sonst um. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-azb-quick]');
    if (!b) return;
    e.preventDefault();
    var fd = new FormData();
    fd.append('id', b.getAttribute('data-azb-quick'));
    fd.append('quantity', '1');
    addToCart(fd, [b], null, b);
  });

  /* ---------- Menge ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-azb-qty-step]');
    if (!b) return;
    var wrap = b.closest('[data-azb-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = Math.max(1, Math.min(99, v + parseInt(b.getAttribute('data-azb-qty-step'), 10)));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Weiterlesen ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-azb-more]');
    if (!b) return;
    var t = document.getElementById(b.getAttribute('aria-controls'));
    if (!t) return;
    var open = t.classList.toggle('is-collapsed') === false;
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    var label = b.querySelector('[data-azb-label]');
    if (label) label.textContent = open ? b.getAttribute('data-less') : b.getAttribute('data-more');
  });

  /* ---------- Anlass-Filter und Sortierung ---------- */
  function initAll(el) {
    if (el.__azb) return; el.__azb = true;
    var list = el.querySelector('[data-azb-all-list]');
    var items = Array.prototype.slice.call(list.children);
    var count = el.querySelector('[data-azb-all-count]');
    var empty = el.querySelector('[data-azb-all-empty]');
    var chips = el.querySelectorAll('[data-azb-chip]');
    function apply(chip) {
      var type = chip.getAttribute('data-type');
      var handles = (chip.getAttribute('data-handles') || '').split(',').filter(Boolean);
      var max = parseInt(chip.getAttribute('data-max') || '0', 10);
      var n = 0;
      items.forEach(function (li) {
        var show = true;
        if (type === 'list') show = handles.indexOf(li.getAttribute('data-handle')) !== -1;
        if (type === 'price') show = parseInt(li.getAttribute('data-price'), 10) <= max;
        li.hidden = !show;
        if (show) n++;
      });
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      if (count) count.textContent = n === 1 ? '1 Produkt' : n + ' Produkte';
      if (empty) empty.hidden = n > 0;
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { apply(c); }); });
    var sort = el.querySelector('[data-azb-sort]');
    if (sort) sort.addEventListener('change', function () {
      var key = sort.value;
      var sorted = items.slice().sort(function (a, b) {
        var pa = parseInt(a.getAttribute('data-price'), 10), pb = parseInt(b.getAttribute('data-price'), 10);
        if (key === 'price-asc') return pa - pb;
        if (key === 'price-desc') return pb - pa;
        if (key === 'rating') return parseFloat(b.getAttribute('data-reviews')) - parseFloat(a.getAttribute('data-reviews'));
        return parseInt(a.getAttribute('data-pos'), 10) - parseInt(b.getAttribute('data-pos'), 10);
      });
      sorted.forEach(function (li) { list.appendChild(li); });
    });
  }

  /* ---------- Galerie ---------- */
  function initGallery(el) {
    if (el.__azb) return; el.__azb = true;
    var track = el.querySelector('[data-azb-gal-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    if (!slides.length) return;
    var prev = el.querySelector('[data-azb-gal-prev]');
    var next = el.querySelector('[data-azb-gal-next]');
    var count = el.querySelector('[data-azb-gal-count]');
    var thumbs = Array.prototype.slice.call(el.querySelectorAll('[data-azb-gal-thumb]'));
    var current = 0;
    function go(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function update() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i === current && el.__azbReady) return;
      el.__azbReady = true;
      current = i;
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && t.parentElement && t.parentElement.parentElement) {
          var strip = t.parentElement.parentElement;
          if (strip.scrollWidth > strip.clientWidth + 1) {
            var sr = strip.getBoundingClientRect(), tr = t.getBoundingClientRect();
            if (tr.left < sr.left) strip.scrollBy({ left: tr.left - sr.left - 8, behavior: 'smooth' });
            else if (tr.right > sr.right) strip.scrollBy({ left: tr.right - sr.right + 8, behavior: 'smooth' });
          }
        }
      });
      slides.forEach(function (s, k) {
        if (k === i) return;
        var v = s.querySelector('video'); if (v && !v.paused) v.pause();
      });
    }
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { go(current, false); });
    el.addEventListener('azb:media', function (e) {
      var id = String(e.detail && e.detail.mediaId);
      slides.forEach(function (s, k) { if (s.getAttribute('data-media-id') === id) go(k); });
    });
    if (el.getAttribute('data-zoom') === 'true') initZoom(el, slides, function () { return current; }, go);
    update();
  }

  /* ---------- Zoom: dieselbe PhotoSwipe-Lightbox wie die Dachzelt-PDP (vendor-scripts, .pswp aus layout/theme.liquid) ---------- */
  function initZoom(el, slides, getCurrent, go) {
    var btn = el.querySelector('[data-azb-gal-zoom]');
    var zoomable = slides.filter(function (s) { return s.hasAttribute('data-azb-zoom'); });
    if (!zoomable.length) return;
    function ready() { return window.PhotoSwipe && window.PhotoSwipeUI_Default && document.querySelector('.pswp'); }
    // Sichtbare Bildfläche bei object-fit: contain, damit die Öffnen-/Schließen-Animation am Bild ansetzt
    function bounds(item) {
      var img = item.el.querySelector('img');
      var r = (img || item.el).getBoundingClientRect();
      var x = r.left, y = r.top, w = r.width;
      if (img && window.getComputedStyle(img).objectFit === 'contain' && item.w && item.h) {
        var ratio = item.w / item.h;
        if (r.width / r.height > ratio) { w = r.height * ratio; x += (r.width - w) / 2; }
        else { y += (r.height - r.width / ratio) / 2; }
      }
      return { x: x, y: y + (window.pageYOffset || document.documentElement.scrollTop), w: w };
    }
    function open(slide) {
      if (!ready()) return;
      var items = zoomable.map(function (s) {
        var img = s.querySelector('img');
        return {
          msrc: img ? (img.currentSrc || img.src) : '',
          src: s.getAttribute('data-azb-zoom'),
          w: Number(s.getAttribute('data-azb-zoom-w')),
          h: Number(s.getAttribute('data-azb-zoom-h')),
          el: s,
          initialZoomLevel: 1
        };
      });
      var mobile = window.innerWidth <= 699;
      var gallery = new window.PhotoSwipe(document.querySelector('.pswp'), window.PhotoSwipeUI_Default, items, {
        allowPanToNext: false,
        captionEl: false,
        closeOnScroll: false,
        counterEl: false,
        history: false,
        index: Math.max(0, zoomable.indexOf(slide)),
        pinchToClose: false,
        preloaderEl: false,
        scaleMode: 'fit',
        shareEl: false,
        tapToToggleControls: false,
        maxSpreadZoom: mobile ? 1.5 : 2,
        getDoubleTapZoom: function () { return mobile ? 1.2 : 1.5; },
        getThumbBoundsFn: function (i) { return bounds(items[i]); }
      });
      // Beim Schließen steht die Galerie auf dem zuletzt angesehenen Bild
      gallery.listen('close', function () { go(slides.indexOf(zoomable[gallery.getCurrentIndex()]), false); });
      gallery.init();
      // iOS-Scroll-Fix wie theme.Photoswipe (CSS in theme.css: .pswp-open-in-ios)
      if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
        var scrollPos = window.scrollY;
        var sync = function () { document.documentElement.style.setProperty('--window-inner-height', window.innerHeight + 'px'); };
        sync();
        document.documentElement.classList.add('pswp-open-in-ios');
        window.addEventListener('resize', sync);
        gallery.listen('destroy', function () {
          document.documentElement.classList.remove('pswp-open-in-ios');
          window.removeEventListener('resize', sync);
          window.scrollTo(0, scrollPos);
        });
      }
    }
    zoomable.forEach(function (s) {
      s.classList.add('is-zoomable');
      s.addEventListener('click', function () { open(s); });
    });
    if (btn) {
      btn.addEventListener('click', function () { open(slides[getCurrent()]); });
      var sync = function () { btn.hidden = !slides[getCurrent()].hasAttribute('data-azb-zoom'); };
      el.querySelector('[data-azb-gal-track]').addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      sync();
    }
  }

  /* ---------- Varianten, Preis, Sticky-Leiste ---------- */
  function initProduct(el) {
    if (el.__azb) return; el.__azb = true;
    var dataEl = el.querySelector('[data-azb-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (err) { variants = []; }
    var form = el.querySelector('form[data-azb-add]');
    var idInput = form && form.querySelector('[name="id"]');
    var opts = Array.prototype.slice.call(el.querySelectorAll('[data-azb-opt]'));
    var price = el.querySelectorAll('[data-azb-price]');
    var was = el.querySelectorAll('[data-azb-was]');
    var spare = el.querySelectorAll('[data-azb-spare]');
    var atcs = document.querySelectorAll('[data-azb-atc="' + el.id + '"]');
    var gallery = el.querySelector('[data-azb-gal]');
    function selected() {
      return opts.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function onChange() {
      var sel = selected();
      var v = variants.filter(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); })[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      price.forEach(function (p) { p.textContent = euro(v.price); });
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      was.forEach(function (w) { w.hidden = !onSale; var n = w.querySelector('s') || w; if (onSale) n.textContent = euro(v.compare_at_price); });
      spare.forEach(function (s) { s.hidden = !onSale; if (onSale) s.textContent = 'Spare ' + euro(v.compare_at_price - v.price).replace(',00', ''); });
      atcs.forEach(function (b) {
        b.disabled = !v.available;
        var label = b.querySelector('[data-azb-label]');
        if (label) label.textContent = v.available ? b.getAttribute('data-label-on') : b.getAttribute('data-label-off');
        var bp = b.querySelector('[data-azb-btn-price]'); if (bp) bp.textContent = euro(v.price);
      });
      if (v.featured_media_id && gallery) gallery.dispatchEvent(new CustomEvent('azb:media', { detail: { mediaId: v.featured_media_id } }));
      var stImg = el.querySelector('[data-azb-sticky-img]');
      if (stImg && v.img) { stImg.src = v.img; stImg.removeAttribute('srcset'); }
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
      }
    }
    opts.forEach(function (fs) { fs.addEventListener('change', onChange); });

    var sticky = document.querySelector('[data-azb-sticky="' + el.id + '"]');
    var main = el.querySelector('[data-azb-main-atc]');
    if (sticky && main) {
      /* Kaufkarte mobil: Platz neben „Fragen?“ (Chatarmin) und Telefon-Button lassen.
         Unter 205 px Breite fällt das Icon weg, unter 180 px (320-px-Handys) bleibt nur der Button. */
      var place = function () {
        var vw = document.documentElement.clientWidth, vh = window.innerHeight;
        var floats = ['#cx-armin-chat-widget-v2 button', '#ScbButton'].map(function (q) { return document.querySelector(q); })
          .filter(function (b) {
            if (!b) return false;
            var r = b.getBoundingClientRect(), cs = getComputedStyle(b);
            return r.width > 0 && r.height > 0 && cs.visibility !== 'hidden' && cs.opacity !== '0' && r.left > vw * 0.4 && r.bottom > vh - 200;
          })
          .map(function (b) { return b.getBoundingClientRect(); });
        var right = '', bottom = '', w = Math.min(vw - 24, 420);
        if (floats.length) {
          var left = Math.min.apply(null, floats.map(function (r) { return r.left; }));
          var low = Math.max.apply(null, floats.map(function (r) { return r.bottom; }));
          right = (vw - left + 8) + 'px'; bottom = Math.max(8, vh - low) + 'px'; w = left - 20;
        }
        sticky.style.right = right; sticky.style.bottom = bottom;
        sticky.classList.toggle('is-narrow', w < 205);
        sticky.classList.toggle('is-tiny', w < 180);
      };
      var shown = false;
      var check = function () {
        var on = main.getBoundingClientRect().bottom < 0;
        if (on && !shown) place();
        shown = on;
        sticky.classList.toggle('is-visible', on);
      };
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', function () { check(); if (shown) place(); });
      check();
    }
  }

  /* ---------- Passt dazu (Empfehlungen per Section Rendering) ---------- */
  function initRel(el) {
    if (el.__azb) return; el.__azb = true;
    var urls = [el.getAttribute('data-url'), el.getAttribute('data-url-fallback')].filter(Boolean);
    function load(k) {
      if (k >= urls.length) { el.closest('[data-azb-rel-wrap]') && (el.closest('[data-azb-rel-wrap]').hidden = true); return; }
      fetch(urls[k]).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('[data-azb-rel-list]');
        if (list && list.children.length) { el.innerHTML = ''; el.appendChild(list); }
        else load(k + 1);
      }).catch(function () { load(k + 1); });
    }
    load(0);
  }

  /* ---------- Zubehör-Seite: Modell-Finder (sections/arcta-zb-finder) ---------- */
  function initFinder(el) {
    if (el.__azb) return; el.__azb = true;
    var grid = el.querySelector('[data-azb-fm-grid]');
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-azb-fm-item]'));
    var help = grid.querySelector('[data-azb-fm-help]');
    var models = Array.prototype.slice.call(el.querySelectorAll('[data-azb-fm-model]'));
    var segs = Array.prototype.slice.call(el.querySelectorAll('[data-azb-fm-group]'));
    var filler = el.querySelector('[data-azb-fm-filler]');
    var title = el.querySelector('[data-azb-fm-title]');
    var sub = el.querySelector('[data-azb-fm-sub]');
    var reset = el.querySelector('[data-azb-fm-reset]');
    var resetLabel = el.querySelector('[data-azb-fm-reset-label]');
    var key = el.getAttribute('data-key');
    var hasBest = items.some(function (li) { return li.getAttribute('data-best') !== ''; });
    function store(v) { try { if (v) window.localStorage.setItem(key, v); else window.localStorage.removeItem(key); } catch (err) {} }
    function showGroup(g) {
      var n = 0;
      segs.forEach(function (s) { var on = s.getAttribute('data-azb-fm-group') === g; s.classList.toggle('is-active', on); s.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      models.forEach(function (m) { var on = m.getAttribute('data-group') === g; m.hidden = !on; if (on) n++; });
      if (filler) filler.hidden = n % 2 === 0;
    }
    function pos(li, id) {
      var m = (' ' + (li.getAttribute('data-ord') || '')).match(new RegExp(' ' + id + ':(\\d+)'));
      return m ? parseInt(m[1], 10) : 999;
    }
    function select(id, save) {
      var m = id ? models.filter(function (x) { return x.getAttribute('data-azb-fm-model') === id; })[0] : null;
      var list;
      models.forEach(function (x) { var on = x === m; x.classList.toggle('is-selected', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      if (m) {
        showGroup(m.getAttribute('data-group'));
        list = items.filter(function (li) { return (' ' + li.getAttribute('data-models') + ' ').indexOf(' ' + id + ' ') > -1; })
          .sort(function (a, b) { return pos(a, id) - pos(b, id); });
        var name = m.getAttribute('data-name');
        var tpl = (list.length === 1 ? el.getAttribute('data-title-one') : el.getAttribute('data-title')) || name;
        title.textContent = tpl.replace('{anzahl}', list.length).replace('{dein}', m.getAttribute('data-dein') || '').replace('{modell}', name).replace(/\s+/g, ' ').trim();
        sub.textContent = m.getAttribute('data-hint') || '';
        if (resetLabel) resetLabel.textContent = name;
        if (reset) reset.hidden = false;
      } else {
        list = items.filter(function (li) { return !hasBest || li.getAttribute('data-best') !== ''; })
          .sort(function (a, b) { return (parseInt(a.getAttribute('data-best'), 10) || 0) - (parseInt(b.getAttribute('data-best'), 10) || 0); });
        title.textContent = title.getAttribute('data-default');
        sub.textContent = sub.getAttribute('data-default');
        if (reset) reset.hidden = true;
      }
      sub.hidden = !sub.textContent;
      items.forEach(function (li) { li.hidden = true; });
      list.forEach(function (li) { li.hidden = false; grid.appendChild(li); });
      if (help) { help.hidden = !m || list.length >= 4; grid.appendChild(help); }
      if (save) store(m ? id : '');
    }
    models.forEach(function (m) {
      m.addEventListener('click', function () {
        var id = m.getAttribute('data-azb-fm-model');
        select(m.classList.contains('is-selected') ? '' : id, true);
      });
    });
    segs.forEach(function (s) { s.addEventListener('click', function () { showGroup(s.getAttribute('data-azb-fm-group')); }); });
    if (reset) reset.addEventListener('click', function () { select('', true); });
    el.addEventListener('shopify:block:select', function (e) {
      var id = e.detail && e.detail.blockId;
      if (id && models.some(function (x) { return x.getAttribute('data-azb-fm-model') === id; })) select(id, false);
    });
    var saved = null;
    try { saved = window.localStorage.getItem(key); } catch (err) {}
    if (saved && models.some(function (x) { return x.getAttribute('data-azb-fm-model') === saved; })) select(saved, false);
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-azb-all]').forEach(initAll);
    scope.querySelectorAll('[data-azb-gal]').forEach(initGallery);
    scope.querySelectorAll('[data-azb-product]').forEach(initProduct);
    scope.querySelectorAll('[data-azb-rel]').forEach(initRel);
    scope.querySelectorAll('[data-azb-finder]').forEach(initFinder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
